import styled from 'styled-components';

import { Color, StyledComponent } from '@rehau-fe/ui/src';

export const Container: StyledComponent<'div'> = styled.div`
  min-height: 393px;
  background-color: ${Color.BgGrey};
  padding-top: 50px;
`;
